import Divider from "@mui/material/Divider";
import ErrorIcon from "@mui/icons-material/Error";
import { Box, Button, Chip, Container, Grid } from "@mui/material";

export const NotFound = () => (
  <Container maxWidth="sm" component="main" sx={{ marginBlock: "auto" }}>
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Chip color="error" label="404: Page not found" icon={<ErrorIcon />} />

      <Divider sx={{ m: 2 }} />

      <Grid container justifyContent="center">
        <Button href="/" variant="contained" size="small">
          Home
        </Button>
      </Grid>
    </Box>
  </Container>
);
